// reducers/profileReducer.js
import * as types from "../types/adminRoleTypes";

const initialState = {
  data: { data: null },
  loading: false,
  error: null,
};

const adminRoleAccessReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ADMIN_ROLE_ACCESS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_ADMIN_ROLE_ACCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case types.FETCH_ADMIN_ROLE_ACCESS_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default adminRoleAccessReducer;
